// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../../scalars/Scalars.bs.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReadMoreButton = require("../../../components/buttons/ReadMoreButton.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var NotificationsUtils = require("../../../v5/common/notifications/NotificationsUtils.bs.js");
var FragmentErrorBoundary = require("../../../v5/common/ErrorHandling/FragmentErrorBoundary.bs.js");
var NotificationWidgetItem = require("./NotificationWidgetItem.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var NotificationWidgetRelay_query_graphql = require("../../../__generated__/NotificationWidgetRelay_query_graphql.bs.js");
var NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql = require("../../../__generated__/NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.bs.js");

var convertFragment = NotificationWidgetRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetRelay_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetRelay_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationWidgetRelay_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetRelay_query_graphql.node, convertFragment, fRef);
}

var QueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Internal.convertVariables;

var convertResponse = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.node, convertResponse, convertWrapRawResponse);

var MarkNotificationReadByCurrentUserMutation_notificationStatus_decode = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Utils.notificationStatus_decode;

var MarkNotificationReadByCurrentUserMutation_notificationStatus_fromString = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Utils.notificationStatus_fromString;

var MarkNotificationReadByCurrentUserMutation = {
  notificationStatus_decode: MarkNotificationReadByCurrentUserMutation_notificationStatus_decode,
  notificationStatus_fromString: MarkNotificationReadByCurrentUserMutation_notificationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function NotificationWidgetRelay$WithoutErrorBoundary(props) {
  var query = use(props.query);
  var isImpersonated = AuthSession.useIsImpersonated();
  var match = use$1();
  var markNotificationAsread = match[0];
  var markAsRead = function (id) {
    if (isImpersonated) {
      return ;
    } else {
      markNotificationAsread({
            input: {
              id: id
            }
          }, undefined, undefined, undefined, undefined, undefined, undefined);
      return ;
    }
  };
  var notifications = Core__Array.filterMap(Core__Option.getOr(Core__Option.flatMap(query.notificationsForCurrentUserV5, (function (v) {
                  return v.edges;
                })), []), (function (v) {
          if (v !== undefined) {
            return v.node;
          }
          
        }));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: NotificationsUtils.NotificationGrouper.groupNotifications(notifications, (function (v) {
                                return Scalars.DateTime.toUTC(v.createdAt);
                              })).map(function (x) {
                            var groupTime = NotificationsUtils.NotificationGrouper.toString(x[0]);
                            return JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("h3", {
                                                children: groupTime,
                                                className: "text-2xl font-medium text-gray-800"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: x[1].map(function (v) {
                                                      return JsxRuntime.jsx(FragmentErrorBoundary.make, {
                                                                  fragmentDisplayName: "notification widget item",
                                                                  children: JsxRuntime.jsx(NotificationWidgetItem.make, {
                                                                        notification: v.fragmentRefs,
                                                                        markAsRead: markAsRead
                                                                      })
                                                                }, v.nodeId);
                                                    }),
                                                className: "mt-4"
                                              })
                                        ]
                                      }, groupTime);
                          }),
                      className: "mb-8 flex flex-col space-y-12"
                    }),
                props.showMore && notifications.length > 0 ? JsxRuntime.jsx(ReadMoreButton.make, {
                        href: "/notifications",
                        children: "View All"
                      }) : null
              ]
            });
}

var WithoutErrorBoundary = {
  make: NotificationWidgetRelay$WithoutErrorBoundary
};

function NotificationWidgetRelay(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "notifications",
              children: JsxRuntime.jsx(NotificationWidgetRelay$WithoutErrorBoundary, {
                    query: props.query,
                    showMore: props.showMore
                  })
            });
}

var NotificationGrouper;

var make = NotificationWidgetRelay;

exports.NotificationGrouper = NotificationGrouper;
exports.QueryFragment = QueryFragment;
exports.MarkNotificationReadByCurrentUserMutation = MarkNotificationReadByCurrentUserMutation;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* commitMutation Not a pure module */
